export default "__VITE_ASSET__DCc9gHLL__"